<div class="d-flex flex-column h-100 gap-8">
  <!-- Top Buttons -->
  <div class="mb-3 d-flex gap-5 align-items-center" data-tour-id="tour-schedule-load">
    <button
      type="button"
      class="btn btn-secondary w-30"
      (click)="openModal(selectScheduleModalTemplate)"
    >
      <i class="icon element-database"></i>{{ 'SHARED.LOAD' | translate }}
    </button>
    <button type="button" class="btn btn-secondary" [cdkMenuTriggerFor]="importContextMenu">
      <i class="icon element-import"></i>{{ 'SHARED.IMPORT' | translate }}
    </button>
  </div>

  <!-- Data Div -->
  @if (selectedSchedule(); as schedule) {
    <div class="d-flex flex-column h-100 gap-5 overflow-hidden">
      <div class="d-flex justify-content-between align-items-start">
        <!-- Title -->
        <div class="mh-46p">
          <div class="d-flex flex-column gap-1 align-items-start">
            <div class="d-flex align-items-center flex-wrap">
              <h3 class="d-inline fw-bold my-0">
                {{ !schedule.id ? (schedule.name | starPrefix) : schedule.name }}
              </h3>

              @if (schedule.version) {
                <h2 class="d-inline my-0 ms-2">
                  <em>{{ schedule.version | bracket }}</em>
                </h2>
              }
              @if (canEdit()) {
                <button
                  type="button"
                  class="btn btn-circle btn-md btn-ghost element-edit ms-3"
                  aria-label="edit"
                  [disabled]="renameInProgress()"
                  (click)="openRenameModal(renameScheduleModalTemplate)"
                ></button>
              }
            </div>

            @if (schedule.description) {
              <small class="text-secondary">{{ schedule.description }}</small>
            }
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn btn-circle btn-lg btn-ghost element-state-close"
            aria-label="close"
            (click)="closeSchedule()"
          ></button>
        </div>
      </div>

      <app-schedule-table
        class="h-100 w-100 overflow-auto"
        data-tour-id="tour-schedule-table"
        [(selectedSchedule)]="selectedSchedule"
        (removeTrackEvent)="removeTrack($event)"
        (trackStationsValidChange)="scheduleTrackStationsValid.set($event)"
        (trackVersionsAccessibleChange)="scheduleTrackVersionsAccessible.set($event)"
        (openLoadTrackModalClicked)="openModal(selectTrackModalTemplate)"
      />
    </div>
    <!-- Bottom Buttons -->
    <div
      class="mt-3 d-flex gap-5 align-items-center w-100 justify-content-end"
      data-tour-id="tour-schedule-actions"
    >
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="!exportButtonEnabled()"
        [cdkMenuTriggerFor]="exportContextMenu"
      >
        <i class="icon element-export"></i>{{ 'SHARED.EXPORT' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary mt-auto"
        [disabled]="!saveButtonEnabled()"
        (click)="saveButtonClicked(saveScheduleModalTemplate, saveUnsavedTracksModalTemplate)"
      >
        <i class="icon element-database"></i>{{ 'SHARED.SAVE' | translate }}
      </button>
      @if (!hasRequiredRole()) {
        <!-- Show only simple Simulate button without dropdown -->
        <div [siTooltip]="!simulateButtonEnabled() ? simulateButtonTooltip() : ''">
          <button
            type="button"
            class="btn btn-primary mt-auto"
            data-tour-id="tour-simulate"
            [disabled]="!simulateButtonEnabled()"
            (click)="startSimulation()"
          >
            {{ 'SCHEDULE.SIMULATE' | translate }}
          </button>
        </div>
      } @else {
        <!-- Show extended Simulation options -->
        @if (showSimulationKernelOptions()) {
          <si-select [options]="simulationKernelOptions" [(ngModel)]="selectedSimulationKernel" />
        }
        <div
          class="btn-group"
          role="group"
          aria-label="Split button primary"
          [siTooltip]="!simulateButtonEnabled() ? simulateButtonTooltip() : ''"
        >
          <button
            type="button"
            class="btn btn-primary mt-auto"
            data-tour-id="tour-simulate"
            [disabled]="!simulateButtonEnabled()"
            (click)="startSimulation()"
          >
            {{ 'SCHEDULE.SIMULATE' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-icon dropdown-toggle"
            aria-label="Dropdown toggle"
            [disabled]="!simulateButtonEnabled()"
            [cdkMenuTriggerFor]="simulateButtonDropdownMenu"
            [class.show]="simulateDropdownOpen"
            (cdkMenuOpened)="simulateDropdownOpen = true"
            (cdkMenuClosed)="simulateDropdownOpen = false"
          >
            <si-icon class="dropdown-caret icon" icon="element-down-2" />
          </button>
        </div>
      }
    </div>
  } @else {
    <div class="d-flex justify-content-center align-items-center h-100">
      <p class="text-center">
        <span>{{
          'SHARED.INFO_LOAD' | translate: { type: ('SCHEDULE.SCHEDULE' | translate) }
        }}</span
        ><br />
        <span>{{ 'SHARED.OR' | translate }}</span>
        <br />
        <button type="button" class="btn btn-tertiary" (click)="createNewSchedule()">{{
          'SHARED.CREATE_NEW' | translate
        }}</button>
      </p>
    </div>
  }
</div>

<!-- Modal Templates -->
<ng-template #selectTrackModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'LOAD_MODAL.HEADING' | translate: { type: ('TRACK.TRACK' | translate) } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <app-load-modal
      class="h-100"
      dataType="track"
      (openItemClicked)="this.closeModal(modalRef); openTrackClicked($event)"
    />
  </div>
</ng-template>

<ng-template #selectScheduleModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'LOAD_MODAL.HEADING' | translate: { type: ('SCHEDULE.SCHEDULE' | translate) } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <app-load-modal
      class="h-100"
      dataType="schedule"
      (openItemClicked)="this.closeModal(modalRef); openScheduleClicked($event)"
    />
  </div>
</ng-template>

<ng-template #saveScheduleModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'SAVE_MODAL.HEADING' | translate: { type: 'Schedule' } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    @if (selectedSchedule(); as schedule) {
      <app-save-modal
        dataType="schedule"
        [itemToSave]="schedule"
        [availableWorkspaces]="availableWorkspaces()"
        (saveItemClicked)="closeModal(modalRef); handleSaveNewSchedule($event)"
      />
    }
  </div>
</ng-template>

<ng-template #renameScheduleModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'SCHEDULE.RENAME.CONFIRM_HEADING' | translate }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    @if (selectedSchedule(); as schedule) {
      <app-save-modal
        class="h-100"
        mode="rename"
        dataType="schedule"
        [itemToSave]="schedule"
        (renameItemClicked)="this.closeModal(modalRef); handleRenameSchedule($event)"
      />
    }
  </div>
</ng-template>

<ng-template #importContextMenu>
  <si-menu>
    <si-menu-item (click)="openFileSelector('json')">JSON</si-menu-item>
    <si-menu-item (click)="openFileSelector('csv')">CSV</si-menu-item>
  </si-menu>
</ng-template>

<!-- Hidden file input -->
<input
  #jsonFileInput
  type="file"
  accept=".json"
  class="d-none"
  (change)="onJSONFileSelected($event)"
/>
<input
  #csvFileInput
  type="file"
  accept=".csv"
  class="d-none"
  (change)="onCSVFileSelected($event)"
/>

<ng-template #exportContextMenu>
  <si-menu>
    <si-menu-item [disabled]="!simulateButtonEnabled()" (click)="exportScheduleDataAsDRIVE()"
      >DRIVE</si-menu-item
    >
    <si-menu-item [disabled]="!simulateButtonEnabled()" (click)="exportScheduleDataAsJSON()"
      >JSON</si-menu-item
    >
    <si-menu-item [disabled]="!exportButtonEnabled()" (click)="exportScheduleDataAsCSV()"
      >CSV</si-menu-item
    >
  </si-menu>
</ng-template>

<ng-template
  #saveUnsavedTracksModalTemplate
  let-modalRef="modalRef"
  let-unsavedTrackInfos="unsavedTrackInfos"
>
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'SCHEDULE.SAVE_UNSAVED_TRACKS_MODAL.HEADING' | translate }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <p class="si-body-1"> {{ 'SCHEDULE.SAVE_UNSAVED_TRACKS_MODAL.MESSAGE' | translate }}</p>
    <ul class="list-group">
      @for (trackInfo of unsavedTrackInfos; track $index) {
        <div class="list-group-item d-flex align-items-center justify-content-between">
          <span>{{ trackInfo.track.scheduleData.stoppingData[0].trackName }}</span>
          @if (selectedSchedule()?.tracks?.[trackInfo.indexInSchedule]?.trackParameters) {
            <button
              type="button"
              class="btn btn-tertiary mt-auto"
              (click)="saveTrackInScheduleButtonClicked($index, saveTrackModalTemplate)"
            >
              <i class="icon element-database"></i>{{ 'SHARED.SAVE' | translate }}
            </button>
          } @else {
            <si-icon
              class="icon"
              icon="element-circle-filled"
              color="status-success"
              stackedIcon="element-state-tick"
              stackedColor="status-success-contrast"
              size="display-3"
            />
          }
        </div>
      }
    </ul>
  </div>
</ng-template>

<ng-template #saveTrackModalTemplate let-modalRef="modalRef" let-track="track">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'SAVE_MODAL.HEADING' | translate: { type: ('TRACK.TRACK' | translate) } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <app-save-modal
      class="h-100"
      mode="save"
      dataType="track"
      [itemToSave]="track"
      [availableWorkspaces]="availableWorkspaces()"
      (saveItemClicked)="this.closeModal(modalRef); handleSaveNewTrack($event)"
    />
  </div>
</ng-template>

<ng-template #simulateButtonDropdownMenu>
  <si-menu>
    <si-menu-item [disabled]="!simulateButtonEnabled()" (click)="startSimulationAndExport()">{{
      'SCHEDULE.SIMULATE_AND_EXPORT' | translate
    }}</si-menu-item>
  </si-menu>
</ng-template>
